<template>
    <div class="card border-0 ticketmainlisting">
        <div class="sectionclsbodymain tsk_body_right_back">
            <div class="serach_controls_main tsk_controls_main_cls">
                <div class="serach_controls_main_row1">
                    <div class="tsk_top_filter_left">
                        <div class="serach_controls me-2">
                            <SearchSvgIcon />
                            <input type="search" class="formmginput-control tsk_search" id="searchTxtId" placeholder="Search..." v-on:keyup="reloadSearch()">
                        </div>
                    </div>                   
                    <div class="tsk_top_filter_right"> 
                        <div class="w-auto me-2">
                            <div class="date-range-picker event-filter-options">
                                    <date-picker
                                        v-model:value="value1"
                                        type="date"
                                        range
                                        format= 'DD-MM-YYYY'
                                        @change="onDateChange"
                                        placeholder="Select date range"
                                        :disabled-date="disableFutureDates" 
                                    ></date-picker>
                            </div>
                        </div>
                        <div class="serach_controlsx w-200 me-2">                    
                            <Multiselect 
                                v-model="$store.state.filterLabelIds" 
                                mode="multiple" 
                                :hide-selected="false" 
                                :caret="true" 
                                :searchable="true" 
                                :create-option="true" 
                                :options="$store.state.labels.LabelsFilterList" 
                                placeholder="Select Status" 
                                v-bind:name="'filterLabelIds[]'" 
                                v-bind:id="'filterLabelIds'"
                                @change="myChangeLabelEvent($event)"  />
                        </div>
                        <div class="serach_controlsx w-200 me-2 me-0">                    
                            <Multiselect 
                                v-model="$store.state.filterPriorityIds" 
                                mode="multiple" 
                                :hide-selected="false" 
                                :caret="true" 
                                :searchable="true" 
                                :create-option="true" 
                                :options="$store.state.priority.PriorityFilterList" 
                                placeholder="Select Priority" 
                                v-bind:name="'filterPriorityIds[]'" 
                                v-bind:id="'filterPriorityIds'"
                                @change="myChangePriorityEvent($event)"  />
                        </div>
                        <div class="serach_controlsx AddtiCket me-0">                    
                            <addTicket @reload-table-data="reloadSearch" ref="childComponentTeamRef"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body p-0">
            <div class="right-bodypart pageTblHeightCls overflow-auto">
                <div class="Setcard_row" v-if="$store.state.ticket.tableLoader === 2">
                    <ComponentNoData />
                </div>
                <div  class="Setcard_row shimmer-wrapper" v-if="$store.state.ticket.tableLoader === 1">                   
                    <div class="card_ticket_S" v-for="index in 8" :key="index">
                        <div class="topsetheadeTcktr">
                            <label class="d-flex">
                                 <span class="stroke animate title w-100"></span>
                            </label>
                        </div>
                        <div class="card_ticket_body" >
                            <label class="d-flex">
                                <span class="stroke animate title w-50 mb-2"></span>
                                <b class="stroke animate title w-25 mb-2"></b>
                            </label>
                            <label class="d-flex">
                                <span class="stroke animate title w-50 mb-2"></span>
                                <b class="stroke animate title w-25 mb-2"></b>
                            </label>    
                            <label class="d-flex">
                                <span class="stroke animate title w-50 mb-2"></span>
                                <b class="stroke animate title w-25"></b>
                            </label>        
                        </div>
                    </div>                    
                </div>
                <div class="Setcard_row" v-if="$store.state.ticket.tableLoader === 3">
                     <div class="card_ticket_S" v-for="(item) in $store.state.ticket.ticketList" :key="item._id" :class="'subTicket-'+item._id">
                        <div class="topsetheadeTcktr">
                            <label class="d-flex">
                                <b><span class="badge" :class="item.color_code">{{ item.label }}</span></b>
                                <div
              class="card_ticket_detai"
              v-if="item.label == 'Resolved' && item.rating"
            >
              <div
                class="rating-wrapper d-flex align-items-center justify-content-center mb-2"
              >
                <span
                  v-for="star in item.rating"
                  :key="star"
                  class="star cursor active"
                  :class="{ active: isHovering ? star <= hoverIndex : star <= rating }"
                  aria-role="button"
                  :aria-label="`Rate ${star} star`"
                  >★</span
                >
              </div>
            </div>
                                <span v-b-tooltip.hover v-bind:title="'View Detail'">
                                    <router-link :to="`/tickets-detail/${encodeBase62(item._id)}`" class="">
                                    <ViewSvgIcon />
                                    </router-link>
                                </span>
                            </label>
                        </div>
                        <div class="card_ticket_header d-flex align-items-center justify-content-between">                            
                            <span class="d-flex align-items-center w-100">
                                <div class="icon">                                    
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.6778 19.957C12.9525 20.021 12.9777 20.3808 12.7101 20.47L11.1301 20.99C7.1601 22.27 5.0701 21.2 3.7801 17.23L2.5001 13.28C1.2201 9.31001 2.2801 7.21001 6.2501 5.93001L6.77409 5.75648C7.17696 5.62306 7.56902 6.02712 7.45463 6.43579C7.39793 6.63837 7.34338 6.84977 7.2901 7.07001L6.3101 11.26C5.2101 15.97 6.8201 18.57 11.5301 19.69L12.6778 19.957Z" fill="#45C49C"/>
                                    <path d="M17.1701 3.21001L15.5001 2.82001C12.1601 2.03001 10.1701 2.68001 9.0001 5.10001C8.7001 5.71001 8.4601 6.45001 8.2601 7.30001L7.2801 11.49C6.3001 15.67 7.5901 17.73 11.7601 18.72L13.4401 19.12C14.0201 19.26 14.5601 19.35 15.0601 19.39C18.1801 19.69 19.8401 18.23 20.6801 14.62L21.6601 10.44C22.6401 6.26001 21.3601 4.19001 17.1701 3.21001ZM15.2901 13.33C15.2001 13.67 14.9001 13.89 14.5601 13.89C14.5001 13.89 14.4401 13.88 14.3701 13.87L11.4601 13.13C11.0601 13.03 10.8201 12.62 10.9201 12.22C11.0201 11.82 11.4301 11.58 11.8301 11.68L14.7401 12.42C15.1501 12.52 15.3901 12.93 15.2901 13.33ZM18.2201 9.95001C18.1301 10.29 17.8301 10.51 17.4901 10.51C17.4301 10.51 17.3701 10.5 17.3001 10.49L12.4501 9.26001C12.0501 9.16001 11.8101 8.75001 11.9101 8.35001C12.0101 7.95001 12.4201 7.71001 12.8201 7.81001L17.6701 9.04001C18.0801 9.13001 18.3201 9.54001 18.2201 9.95001Z" fill="#45C49C"/>
                                    </svg>
                                </div>
                                <i  v-b-tooltip.hover v-bind:title="item.title">{{ item.title }}</i>
                            </span>
                        </div>
                        <div class="card_ticket_body">
                            <label class="d-flex">
                                <span>Ticket Id</span>
                                <b>#{{ item.ticket_id }}</b>
                            </label>                           
                            <label class="d-flex">
                                <span>User</span>
                                <b>{{ item.user_id }}</b>
                            </label>
                            <label class="d-flex">
                                <span>Submitted</span>
                                <b v-b-tooltip.hover v-bind:title="formatDateTime(item.createdAt)">
                                    <timeago v-if="item.createdAt" :datetime="new Date(item.createdAt)" />
                                </b>
                            </label>
                            <label class="d-flex">
                                <span>Priority</span>
                                <b>{{ item.priority }}</b>
                            </label>
                        </div>
                    </div>
                </div>           
            </div>
            <div class="d-flex px-3 databottom justify-content-between align-content-center" v-if="$store.state.ticket.tableLoader == 3">
                <p v-if="page * pageLength > $store.state.ticket.totalRecord">Showing {{ formatMoney((page * pageLength) - pageLength + 1) }} to {{
                    formatMoney($store.state.ticket.totalRecord) }} of {{ formatMoney($store.state.ticket.totalRecord) }} entries</p>
                <p v-else>Showing {{ formatMoney((page * pageLength) - pageLength + 1) }} to {{ formatMoney(page * pageLength) }} of {{
                    formatMoney($store.state.ticket.totalRecord) }} entries</p>
                <vs-pagination :total="$store.state.ticket.totalLenght" :max="8" v-model="page" @click="reloadPagination(page)"></vs-pagination>
            </div>
        </div>
    </div>
    <input type="hidden" class="ticketValId" id="ticketValId"/>
    <LabelsData />
    <PriorityData />
</template>
<script>
import SearchSvgIcon from '@/components/Widgets/Icon/SearchSvgIcon.vue';
import ComponentNoData from '@/components/Widgets/Icon/ComponentNoData.vue';
import LabelsData from '@/backend/components/labels/LabelsData.vue';
import PriorityData from '@/backend/components/priority/PriorityData.vue';
import Multiselect from '@vueform/multiselect'
import $ from "jquery";
import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';
import moment from 'moment'
import ViewSvgIcon from '@/components/Widgets/Icon/ViewSvgIcon.vue';
import { useRoute } from 'vue-router';
import addTicket from './addTicket.vue';
import { onMounted, getCurrentInstance } from 'vue';
import {
    formatMoney,
    formatDateTime,
    encodeBase62,
} from '../../../helper'
import {
    ref
} from 'vue';
import axios from 'axios'
    export default {
        name: 'TicketListingPage',
        components: {
            SearchSvgIcon,
            ComponentNoData,
            ViewSvgIcon,
            DatePicker,
            LabelsData,
            PriorityData,
            Multiselect,
            addTicket,
        },
        data() {
            return {
                windowWidth: window.innerWidth,
                currentx: 5,
                page: 1,
                pageLength: 12,
                searchKey: '',
                totalRecord: 0,
                totalLenght: 0,
                ticketList: [],
                myValue: 'true',
                taskMainListHeight: 0,
                filterLabelIds: [],
                filterPriorityIds: [],
                locale: 'en', // Optional: set your desired locale
                format: 'MM-DD-YYYY',
                sameDateFormat: {
                    from: 'MM-DD-YYYY',
                    to: 'MM-DD-YYYY'
                },
                dateRange: [],
                value1: [new Date(this.$store.state.ticketListStartDate), new Date(this.$store.state.ticketListEndDate)],
            }
        },
        async mounted() {
            this.$store.state.pageTitle = 'Tickets'
            if(this.windowWidth < 991){
                $('.mainbody_cssclass').removeClass('sideMenuActive');
            }
            $('tbody').height(this.$store.state.tbody);
            $('.pageTblHeightCls').height(this.$store.state.pageTblHeightCls);
            this.$store.state.isAdmin = 2
            if (this.$store.state.isActiveToken != '1') {
                // console.log(this.currentDate);
            } else {
                // let today = new Date(this.$store.state.ticketListStartDate);
                // let day = String(today.getDate()).padStart(2, '0');
                // let month = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                // let year = today.getFullYear();
                // this.startDate = `${year}-${month}-${day}`;
                // $('.startDate').val(this.startDate)

                // let todayEnd = new Date(this.$store.state.ticketListEndDate);
                // let dayEnd = String(todayEnd.getDate()).padStart(2, '0');
                // let monthEnd = String(todayEnd.getMonth() + 1).padStart(2, '0'); //January is 0!
                // let yearEnd = todayEnd.getFullYear();
                // this.endDate = `${yearEnd}-${monthEnd}-${dayEnd}`;
                // $('.endDate').val(this.endDate)
                await this.loadTicketData();
            }
            let temps = this
            $("body").on("click", '#searchTxtId', function () {
                if ($('#searchTxtId').val() != '') {
                    $('#searchTxtId').val('');
                    this.searchKey = '';
                    this.page = 1;
                    temps.reloadSearch()
                }
            });
            this.onResize();
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })
        },
        computed: {
            iAT() {
                return this.$store.state.user.role_id
            },
            startDate() {
                return this.dateRange?.[0] ? moment(this.dateRange[0]).format("YYYY-MM-DD") : this.$store.state.ticketListStartDate;
            },
            endDate() {
                return this.dateRange?.[1] ? moment(this.dateRange[1]).format("YYYY-MM-DD") : this.$store.state.ticketListEndDate;
            },
        },
        watch: {
            async iAT(newValue) {
                if (this.$store.state.user.role_id != '') {
                    await this.loadTicketData();
                }
                return newValue
            },
            startDate(newVal) {
              this.$store.state.ticketListStartDate = newVal;
            },
            endDate(newVal) {
              this.$store.state.ticketListEndDate = newVal;
            },
        },
        methods: {
            formatMoney,
            formatDateTime,
            encodeBase62,
            startLoader () {
                this.$Progress.start()
            },
            finishLoader () {
                this.$Progress.finish()
            },
            dateFm(date) {
                let today = new Date(date);
                let day = String(today.getDate()).padStart(2, '0');
                let month = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                let year = today.getFullYear();
                return `${year}-${month}-${day}`;
            },
            myChangeLabelEvent(val) {
                this.$store.state.filterLabelIds = val
                this.loadTicketData();
            },
            myChangePriorityEvent(val) {
                this.$store.state.filterPriorityIds = val
                this.loadTicketData();
            },
            async reloadPagination(itemObjKey) {
                if (itemObjKey > 0 && itemObjKey !== -1 && itemObjKey <= this.$store.state.ticket.totalLenght) {
                    this.page = itemObjKey;
                    this.loadTicketData();
                }
            },
            myChangeEvent(val) {
                this.myValueRole = val
                this.loadTicketData();
            },
            mySelectEvent({ id, text }) {
                console.log({ id, text })
                this.page = 1;
                this.loadTicketData();
            },
            async reloadSearch() {
                const searchCls = document.getElementById('searchTxtId').value;
                this.searchKey = searchCls.trim();
                this.page = 1;
                this.loadTicketData();
            },
            onDateChange(newDates) {
                this.dateRange = newDates; // Update the selected range

                this.loadTicketData();
            },
            async loadTicketData() {
                if (this.$store.state.ticket.ticketList.length > 0) {
                    // this.$store.state.ticket.tableLoader = 3
                } else {
                    this.$store.state.ticket.tableLoader = 1
                }
                let token = localStorage.getItem('supportSystemAdmin');
                if (!token) {
                    this.$store.state.user.accessToken = ''
                }
                this.startLoader()    
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
                await axios.get(process.env.VUE_APP_API_URL + 'ticket/list', {
                        params: {
                            page: this.page,
                            pageLength: this.pageLength,
                            searchKey: this.searchKey,
                            label_id: this.$store.state.filterLabelIds,
                            priority_id: this.$store.state.filterPriorityIds,
                            startDate: this.startDate,
                            endDate: this.endDate
                        }
                    })
                    .then((resp) => {
                        if (resp.status == 200 && resp.data.status == 'success') {
                            this.ticketList = []
                            this.ticketList = resp.data.data.records
                            this.totalRecord = resp.data.data.totalRecord
                            this.totalLenght = this.totalRecord / this.pageLength
                            this.totalLenght = Math.ceil(this.totalLenght);

                            this.$store.state.ticket.ticketList = resp.data.data.records;
                            this.$store.state.ticket.totalLenght = this.totalLenght;
                            this.$store.state.ticket.totalRecord = this.totalRecord;

                            if (this.$store.state.ticket.ticketList.length > 0) {
                                this.$store.state.ticket.tableLoader = 3
                            } else {
                                this.$store.state.ticket.tableLoader = 2
                            }
                            setTimeout(async () =>
                                this.onResize(),
                            100);
                            this.finishLoader()    
                        }else{
                            this.$store.state.user.accessToken = ''
                            this.$store.state.isActiveToken = ''
                            this.$store.state.user.userInfo = ''
                            this.$store.state.isAdmin = 2 
                            localStorage.removeItem("supportSystemAdmin");
                            this.$router.push({
                                path: '/login'
                            })
                        }
                    })
                    .catch(error => {
                        console.error("There was an error!", error);
                        console.log("response", error.response.status);
                        console.log("message", error.response.data.message);
                        // this.errorRes = error.response.data.message;
                    })
            },
            async modalEditOpen(ticket_id) {
                $('.ticketValId').val(ticket_id);
            },
            onResize() {
                this.windowWidth = window.innerWidth
                this.windowHeight = window.innerHeight

                var headNavCls = $('.headNavCls').outerHeight() || 0;
                var tsk_tabs = $('.serach_controls_main').outerHeight() || 0;
                var databottom = $('.databottom').outerHeight() || 0;

                var tabHei = headNavCls + tsk_tabs + databottom
                
                tabHei = this.windowHeight - tabHei - 20
                this.taskMainListHeight = tabHei;
                $('.pageTblHeightCls').height(tabHei);
                this.checkHeightScroll();
            },
            checkHeightScroll() {
                $('.table').removeClass('ScrollAddedCls');
                if (this.hasScrollBar() == true) {
                    $('.table').addClass('ScrollAddedCls');
                }
            },
            hasScrollBar() {
                if ($(".tbodyCls")[0]) {
                    return $('.tbodyCls').get(0).scrollHeight > $('.tbodyCls').height() + 10;
                } else {
                    return false;
                }
            },
        },
        setup() {
            const route = useRoute();
            const childComponentTeamRef = ref(null);
            const selectedDate = ref(null);

            // Function to disable future dates
            const disableFutureDates = (date) => {
                return date.getTime() > new Date().getTime(); // Disable dates beyond today
            };
            onMounted(() => {
                const name = route.query.name; // Get 'name' from URL
                const instance = getCurrentInstance(); // Get Vue instance
                if (name) {
                    $('.tsk_search').val(name);
                    instance.proxy.reloadSearch();
                }
            });

            return { route, childComponentTeamRef, selectedDate, disableFutureDates };
        }
    }
</script>
<style src="@vueform/multiselect/themes/default.css"></style>

<style scoped>
.rating-wrapper {
  user-select: none;
  background: white;
}
.star {
  font-size: 24px;
  color: #e0e0e0;
  margin: 0 4px;
  transition: color 0.15s ease, transform 0.1s ease;
  display: inline-block;
}
.star:hover {
  transform: scale(1.1);
}

/* Selected stars: rely only on the active class set by Vue */
.star.active {
  color: #f5b301;
}
.star.preview {
  color: #ffd766;
}

/* Hover preview color handled via class binding; keep base styles simple */

.rating-wrapper .star:not(.active):not(:hover) {
  cursor: pointer;
}
.feedback-wrapper .form-control {
  border-radius: 8px;
  min-height: 120px;
  resize: vertical;
}
</style>